export enum HoursOfOperationDisplayType {
    Unknown = 0,
    Open = 1,
    AfterHours = 2,
    Closed = 3
}
